export const Login = 'login';
export const SignUp = 'sign-up';
export const ResetPassword = 'reset-password';
export const ForgotPassword = 'forgot-password';
